<template>
    <!-- 附件 弹框 -->
    <el-dialog
        v-drag
        :closeOnClickModal='false'
        class="attachment receiptSignattachment"
        title="附件预览"
        :visible="true"
        :before-close="beforeClose"
        width="40%"
        append-to-body>
        <div class="attachmentLeft">
            <div style="height: 300px;">
                <div class="img-item" style="display: none;" id="viewers">
                    <img :src="imgSrc">
                </div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
/**
 * 功能: 支持图片、office文件预览，不支持exe、dll等不可预览格式文件的预览
 * @param rowData {Object}
 * @param rowData.downUrl {String} 这是必要参数
 * @param rowData.fileId  {String}
 * @param rowData.fileName {String}
 * **/
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';
import { filePreview } from '@/utils/filePreview.js';

export default {
    props: {
        attachmentShow: {
            type: Boolean,
            default() {
                return false;
            }
        },
        rowData: {
            type: Object,
            default() {
                return {};
            }
        },
        certification: {
            type: String,
            default() {
                return '';
            }
        }
    },
    data() {
        return {
            updateTime: '',
            updateUserName: '',
            imgSrc: '',
            viewer: {}
        };
    },
    methods: {
        beforeClose() {
            this.$emit('update:attachmentShow', false);
        },
        initViewer() {
            const barOptions = { show: true, size: 'small' };
            this.viewer = new Viewer(document.getElementById('viewers'), {
                inline: true,
                title: false,
                navbar: false,
                button: true,
                toolbar: {
                    zoomIn: barOptions,
                    zoomOut: barOptions,
                    prev: { show: false },
                    reset: barOptions,
                    next: { show: false },
                    rotateLeft: barOptions,
                    rotateRight: barOptions
                }
            });
        },
        getImgList() {
            // this.updateTime = this.rowData.updateTime;
            // this.updateUserName = this.rowData.updateUserName;
            this.imgSrc = this.rowData.downUrl;
            this.$nextTick(() => {
                this.initViewer();
            });
        }
    },
    mounted() {
        const imagesReg = /\.(jpg|bmp|gif|ico|pcx|jpeg|tif|png|raw|tga)$/;
        const officeReg = /\.(doc|docx|xls|xlsx|ppt|pptx|pdf|txt)$/;
        const fileType = this.rowData.downUrl.slice(this.rowData.downUrl.lastIndexOf('.'));
        if (imagesReg.test(fileType.toLowerCase())) {
            this.getImgList();
            return;
        }
        if (officeReg.test(fileType.toLowerCase())) {
            const fileUrl = this.rowData.downUrl.replace(/^https/, 'http');
            const form = {
                fileName: this.rowData.fileName || '',
                fileId: this.rowData.fileId || '',
                fileUrl: fileUrl
            };
            filePreview(form);
            this.$emit('update:attachmentShow', false);
            return;
        }
        this.$emit('update:attachmentShow', false);
        this.$message.warning('该文件格式不支持预览');
    }
};
</script>
<style lang="less">
.attachment {
    .attachmentTitle {
        margin: 10px 0;
        font-size: 14px;
    }
    .attachmentLeft {
        .img-item {
            width: 98%;
            height: 96%;
        }
    }
}
</style>